module.exports = __webpack_public_path__ + "assets/img/unity3d-icon.bf401787.svg";